var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 22,
    viewBox: "0 0 32 32",
    width: 22,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.867 14.881a4.941 4.941 0 1 0 -4.941-4.94 4.946 4.946 0 0 0 4.941 4.94zm0-7.881a2.941 2.941 0 1 1 -2.941 2.941 2.945 2.945 0 0 1 2.941-2.941z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.533 17.785a3.8 3.8 0 1 0 -3.8-3.8 3.8 3.8 0 0 0 3.8 3.8zm0-5.6a1.8 1.8 0 1 1 -1.8 1.8 1.8 1.8 0 0 1 1.8-1.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 17.785a3.8 3.8 0 1 0 -3.8-3.8 3.8 3.8 0 0 0 3.8 3.8zm0-5.6a1.8 1.8 0 1 1 -1.8 1.8 1.8 1.8 0 0 1 1.8-1.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.333 19.791a5.269 5.269 0 0 0 -2.506.653 8.237 8.237 0 0 0 -6.827-3.837 8.237 8.237 0 0 0 -6.827 3.837 5.269 5.269 0 0 0 -2.506-.653 5.963 5.963 0 0 0 -5.667 6.209 1 1 0 0 0 2 0 3.971 3.971 0 0 1 3.667-4.209 3.272 3.272 0 0 1 1.577.419 10.085 10.085 0 0 0 -.711 3.732 1 1 0 0 0 2 0c0-4.045 2.9-7.335 6.467-7.335s6.467 3.29 6.467 7.335a1 1 0 0 0 2 0 10.085 10.085 0 0 0 -.711-3.732 3.272 3.272 0 0 1 1.577-.419 3.971 3.971 0 0 1 3.667 4.209 1 1 0 0 0 2 0 5.963 5.963 0 0 0 -5.667-6.209z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.afec0aead91a26cb5518ce1536a4a86d.svg";
export { ForwardRef as ReactComponent };